import * as React from "react";
import {imageBaseUrl} from "config";
import {Link} from "react-router-dom";

const slRightPanel = <div className="row d-md-flex d-md-none d-none"
                          style={{textAlign: "center", display: "flex", justifyContent: "center",
                              alignItems: "center"}}>
    <div className="col-12 col-md-10" style={{padding: 0, marginBottom: 15}}>
        <Link to="referralLink" style={{textDecoration: "none"}}>
            <img src={`${imageBaseUrl}/img/referImg.png`} alt="Refer" style={{width: "100%"}}/>
        </Link>
    </div>
</div>;

export const appConfig = {
    sl: {
        btnColor: "#F5821F",
        textColor: "white",
        rightPanelColor: "#edf8fb",
        navigationTextColor: "#fd7303",
        percentageColor: "#28a745",
        width: "100%",
        rightPanel: slRightPanel,
        leftPanelTextColor: "#8b8b8b",
        leftPanelBgColor: "white",
        loginBgColor: "#fd7303",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/home/loan_amount.jpg`,
                altText: "",
                caption: "",
            },
            {
                src: `${imageBaseUrl}/img/home/tenure.jpg`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: null,
        loginCardText: null,
        showCoBrandingInFooter: false,
        showCoBrandingCard: true,
        centerLogin: false,
    },
    letsMd: {
        width: "100%",
        btnColor: "#F5821F",
        textColor: "white",
        rightPanelColor: "#28a745",
        navigationTextColor: "#007bff",
        percentageColor: "#49a746",
        rightPanel: null,
        leftPanelTextColor: "#8b8b8b",
        leftPanelBgColor: "white",
        loginBgColor: "#28a745",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/letsmd_logo.png`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCLMD",
        contactNumbers: ["9205987552",
            "9205987553"],
        logoUrl: `${imageBaseUrl}/img/partners/letsmd_logo.png`,
        rightPanelTextColor: "white",
        loginCardText: null,
        showCoBrandingInFooter: true,
        showCoBrandingCard: true,
        centerLogin: false,
    },
    lendingTree: {
        btnColor: "#238CB2",
        textColor: "white",
        rightPanelColor: "#238CB2",
        navigationTextColor: "#238CB2",
        percentageColor: "#49a746",
        rightPanel: null,
        leftPanelTextColor: "#238CB2",
        loginBgColor: "#238CB2",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/lending_tree.jpg`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCLT",
        contactNumbers: ["88807527752"],
        logoUrl: `${imageBaseUrl}/img/partners/lending_tree.jpg`,
        rightPanelTextColor: "white",
        loginCardText: null,
        showCoBrandingInFooter: false,
        showCoBrandingCard: true,
        centerLogin: false,
    },
    myMoneyMantra: {
        btnColor: "#89C142",
        textColor: "white",
        rightPanelColor: "#89C142",
        navigationTextColor: "#89C142",
        percentageColor: "#49a746",
        leftPanelTextColor: "#89C142",
        rightPanel: null,
        loginBgColor: "#89C142",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/my_money_mantra.png`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCMMM",
        contactNumbers: ["88807527752"],
        logoUrl: `${imageBaseUrl}/img/partners/my_money_mantra.png`,
        rightPanelTextColor: "white",
        loginCardText: "In Partnership with",
        showCoBrandingInFooter: true,
        showCoBrandingCard: true,
        centerLogin: false,
    },
    paisaBazzar: {
        btnColor: "#026692",
        textColor: "white",
        rightPanelColor: "#026692",
        navigationTextColor: "#026692",
        percentageColor: "#026692",
        leftPanelTextColor: "#026692",
        rightPanel: null,
        loginBgColor: "#026692",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/paisa_bazzar.png`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCPB",
        contactNumbers: ["88807527752"],
        logoUrl: `${imageBaseUrl}/img/partners/paisa_bazzar.png`,
        rightPanelTextColor: "white",
        loginCardText: null,
        showPoweredByInFooter: false,
        showCoBrandingInFooter: true,
        centerLogin: false,
    },
    earnWealth: {
        btnColor: "#28a745",
        textColor: "white",
        rightPanelColor: "#000bff",
        navigationTextColor: "#fd7303",
        percentageColor: "#28a745",
        rightPanel: null,
        leftPanelTextColor: "#000bff",
        loginBgColor: "#fd7303",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/earn_wealth.jpg`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCEW",
        contactNumbers: ["88807527752"],
        logoUrl: `${imageBaseUrl}/img/partners/earn_wealth.jpg`,
        rightPanelTextColor: "#000bff",
        loginCardText: null,
        showCoBrandingInFooter: false,
        showCoBrandingCard: true,
        centerLogin: false,
    },
    betterPlace: {
        btnColor: "#00793A",
        textColor: "white",
        rightPanelColor: "#00793A",
        navigationTextColor: "#00793A",
        percentageColor: "#00793A",
        rightPanel: null,
        leftPanelTextColor: "#00793A",
        loginBgColor: "#00793A",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/better_place.png`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCBP",
        contactNumbers: ["88807527752"],
        logoUrl: `${imageBaseUrl}/img/partners/better_place.png`,
        rightPanelTextColor: "white",
        loginCardText: "In Partnership with",
        showCoBrandingInFooter: true,
        showCoBrandingCard: false,
        centerLogin: true,
    },
    vserveLoans: {
        btnColor: "#FFA726",
        textColor: "white",
        rightPanelColor: "#3abcdc",
        navigationTextColor: "#42A5F5",
        percentageColor: "#42A5F5",
        rightPanel: null,
        leftPanelTextColor: "#163564",
        loginBgColor: "#42A5F5",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/vserveLogo.png`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCVL",
        contactNumbers: ["88807527752"],
        logoUrl: `${imageBaseUrl}/img/partners/vserveLogo.png`,
        rightPanelTextColor: "white",
        loginCardText: "In Partnership with",
        showCoBrandingInFooter: true,
        showCoBrandingCard: true,
        centerLogin: true,
    },
    myFi: {
        btnColor: "#FFA726",
        textColor: "white",
        rightPanelColor: "#3abcdc",
        navigationTextColor: "#419fc1",
        percentageColor: "#42A5F5",
        rightPanel: null,
        leftPanelTextColor: "#163564",
        loginBgColor: "#42A5F5",
        sliderItems: [
            {
                src: `${imageBaseUrl}/img/partners/myfilogo.png`,
                altText: "",
                caption: "",
            },
        ],
        allowApply: true,
        defaultSourcingCode: "SCMF",
        contactNumbers: ["88807527752"],
        logoUrl: `${imageBaseUrl}/img/partners/myfilogo.png`,
        rightPanelTextColor: "white",
        loginCardText: "In Partnership with",
        showCoBrandingInFooter: true,
        showCoBrandingCard: true,
        centerLogin: true,
    },
};
